import * as Yup from 'yup';

export const emptyAnalysis = () => ({
  title: '',
  body: '',
  tags: [],
  linkedAdjustments: [],
});

export const analysisSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
});
